import { action, makeObservable, observable } from "mobx";
import { AnimalProposal, AnimalProposalModel } from "./catAndDogProposal";

export interface AnimalsProposalModel {
    animals: AnimalProposalModel[];

    setNumberOfAnimals: (count: number) => void;
    validate: () => void;
    clearErrorMessages: () => void;
    reset: () => void;
}



export class AnimalsProposal implements AnimalsProposalModel {
    @observable animals = [] as AnimalProposalModel[];

    constructor() {
        makeObservable(this);

        this.setNumberOfAnimals(4);
    }

    @action
    public setNumberOfAnimals(count: number) {
        const animalsCount = this.animals.length;
        const diff = count - animalsCount;

        if (diff > 0) {
            for (let i = 0; i < diff; i++) {
                this.animals.push(new AnimalProposal() );
            }
        } else if (diff < 0) {
            for (let i = 0; i < Math.abs(diff); i++) {
                this.animals.pop();
            }
        }
    }

    @action
    public reset() {
        this.animals = [];
    }

    @action
    public validate() {
        this.animals.forEach(animal => {
            animal.name.validate();
            animal.race.validate();
            animal.age.validate();
        });
    }

    @action
    public clearErrorMessages() {
        this.animals.forEach(animal => {
            animal.name.errorMessage = "";
            animal.race.errorMessage = "";
            animal.age.clearValidation();
        });
    }
}

